// CHEAT SHEET: https://gist.github.com/mrmartineau/a4b7dfc22dc8312f521b42bb3c9a7c1e
import AdvancedController from "./advanced-controller";
import { fadeIn, fadeOut } from "../animations/animation-fade";

export default class ContactFormChoiceController extends AdvancedController {
  static targets = ["contactForm", "offerForm"];

  connect() {
    super.connect(...arguments);
  }

  onRadioChange(event) {
    const value = event.target.value;
    if (value === "contact-us") {
      this.contactFormTarget.style.position = "relative";
      fadeIn(this.contactFormTarget);
      this.offerFormTarget.style.position = "absolute";
      fadeOut(this.offerFormTarget);
    } else if (value === "offer") {
      this.offerFormTarget.style.position = "relative";

      fadeIn(this.offerFormTarget);
      this.contactFormTarget.style.position = "absolute";
      fadeOut(this.contactFormTarget);
    }
  }
}
